import classNames from 'classnames';
import { useContext } from 'react';

import InstagramIcon from '@components/icons/InstagramIcon';
import MailIcon from '@components/icons/MailIcon';
import { Locales, WithClassName } from '@types';
import { IntlContext } from '@utils/useIntl';

interface NavLinksProps {
  size?: 'md' | 'lg';
}

const NavLinks = ({
  className,
  size = 'md',
}: NavLinksProps & WithClassName) => {
  const { locale, setLocale, translate } = useContext(IntlContext);

  return (
    <div className={classNames('flex items-center gap-4', className)}>
      {/* Links */}
      <a
        title="instagram"
        href="https://www.instagram.com/marcmalignan/"
        target="_blank"
      >
        <InstagramIcon size={size === 'lg' ? 36 : 19} />
      </a>
      <a
        title={translate('nav.links.email')}
        href="mailto:contact@marcmalignan.com"
        target="_blank"
      >
        <MailIcon size={size === 'lg' ? 38 : 20} />
      </a>

      {/* Locales */}
      <div
        className={classNames(
          'flex font-text',
          size === 'lg' ? 'ml-10 gap-4' : 'ml-4 gap-2 text-sm',
        )}
      >
        {Object.values(Locales).map((l) => (
          <span
            key={l}
            className={classNames(
              'border-b hover:text-accent transition-colors cursor-pointer',
              l === locale
                ? 'border-white hover:border-accent'
                : 'border-transparent',
            )}
            onClick={() => setLocale(l)}
          >
            {l}
          </span>
        ))}
      </div>
    </div>
  );
};

export default NavLinks;
